module.exports = __webpack_public_path__ + "fonts/NimbusMonoL-Bold.59536c24.ttf";